import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from 'react';
import cls from 'classnames';
import { useSetState, useControllableValue } from 'ahooks';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import './index.less';
/**
 *
 * @param 菜单收起展开
 * @returns
 */
const Trigger = ({ setCollapsed, pxWidth, setSiderWidth, collapsed }) => {
    return (_jsx("div", { className: "ant-sider-trigger", style: { width: pxWidth }, onClick: () => {
            setCollapsed((_collapsed) => {
                if (!_collapsed) {
                    setSiderWidth(79);
                }
                else {
                    setSiderWidth(200);
                }
                return !_collapsed;
            });
        }, children: collapsed ? _jsx(MenuFoldOutlined, {}) : _jsxs("span", { children: [_jsx(MenuUnfoldOutlined, {}), " ", _jsx("span", { className: 'show-hidden-menu', children: "\u6536\u8D77\u83DC\u5355" }), " "] }) }));
};
export const Dragging = (props) => {
    const { siderMinWidth = 200, siderMaxWidth = 480, mode = 'side', isResizable = true, splitLineStyle = {}, splitLineClassName = '', siderStyle = {}, siderClassName = '', children, layoutHeight = '100vh', setCollapsed, collapsed, } = props;
    const [state, setState] = useSetState({
        dragging: false,
        isOver: false,
        startPageX: 0,
    });
    const { dragging, startPageX } = state;
    const ref = useRef(null);
    const [siderWidth = 200, setSiderWidth] = useControllableValue(props, {
        valuePropName: 'siderWidth',
    });
    const pxWidth = `${siderWidth}px`;
    useLayoutEffect(() => {
        document.documentElement?.style.setProperty('--sider-bar-height', typeof layoutHeight === 'number' ? `${layoutHeight}px` : layoutHeight);
    }, [layoutHeight]);
    const handleMouseDown = (event) => {
        setState({
            startPageX: event.pageX,
            dragging: true,
        });
    };
    const handleMouseMove = (event) => {
        const currentSiderWidth = siderWidth + event.pageX - startPageX;
        if (currentSiderWidth < siderMinWidth ||
            currentSiderWidth > siderMaxWidth) {
            // @ts-ignore
            event.currentTarget.style.cursor = 'not-allowed';
            return;
        }
        // @ts-ignore
        if (event.currentTarget.style.cursor === 'not-allowed') {
            // @ts-ignore
            event.currentTarget.style.cursor = 'ew-resize';
        }
        setSiderWidth(currentSiderWidth);
        setState({ startPageX: event.pageX, isOver: false });
    };
    const layoutProps = mode === 'overlay' ? {} : { style: { paddingLeft: pxWidth } };
    return (_jsxs("aside", { id: "antd-layout-left", ...layoutProps, children: [_jsx("div", { className: cls('antd-sider', siderClassName), style: { ...siderStyle, width: pxWidth }, onMouseOver: () => setState({ isOver: true }), onMouseOut: () => setState({ isOver: false }), children: _jsxs("div", { children: [_jsx("div", { className: "antd-sider-menu", children: children }), _jsx(Trigger, { setCollapsed: setCollapsed, pxWidth: pxWidth, setSiderWidth: setSiderWidth, collapsed: collapsed })] }) }), isResizable ? (_jsx("div", { className: cls('antd-sider-resizer', splitLineClassName), style: splitLineStyle, onMouseDown: handleMouseDown, onMouseOver: () => setState({ isOver: true }), onMouseOut: () => setState({ isOver: false }), children: dragging && (_jsx("div", { ref: ref, className: "antd-resize-mask", onMouseMove: handleMouseMove, onMouseUp: () => setState({ dragging: false }) })) })) : (_jsx("div", { style: { left: siderWidth, ...splitLineStyle }, className: cls('antd-sider-disable-resizer', splitLineClassName) }))] }));
};
